export default "__VITE_ASSET__BzpcH67m__"